import { useRef, useState, useEffect } from 'react';
import TextBoxNumericControl from "../../../Controls/TextBoxNumericControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import GridControl from "../../../Controls/GridControl"
import DescriptionControl from "../../../Controls/DescriptionControl"
import { useNavigate } from "react-router-dom";
import TextAreaControl from "../../../Controls/TextAreaControl";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ShowFilesReviewAbstractListAdmin from "../../../Controls/ShowFilesReviewAbstractListAdmin"

import {
	GetLocal,
	SetLocal,
	FetchService,
	IsEmptyInput
} from "../../../Base/BaseControl";
import { toast } from 'react-toastify';
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

let ServiceUrlCheckBox = '';
let ShowSuccess = null;
let ResultRow = '';

export default function Index(props) {
	const inputRef = useRef(null);
	const navigate = useNavigate();

	const inpFilesRef = useRef(null);
	const inpDescriptionRef = useRef(null);

	const [value, setValue] = useState(0);
	const [getShowModal, setShowModal] = useState(false);
	const inpTelRef = useRef(null);
	const [getServiceResult, setServiceResult] = useState(false);
	const [getSelectData, setSelectData] = useState([]);
	const [getResultRow, setResultRow] = useState(null);
	const [getFileNumberState, setFileNumberState] = useState(true);

	useEffect(() => {
		SetTypeLevel('AdminUrbanizationApprovalByAllFiles');
	}, []);

	const AdminUrbanizationApprovalByFileNumber = () => {
		if (IsEmptyInput(inpFilesRef))
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: Number(inpFilesRef.current.value)
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/AdminUrbanizationApprovalByFileNumber", inputValue, AdminUrbanizationApprovalByFileNumberSuccess, ServiceResultFail);
	}

	const AdminUrbanizationApprovalByFileNumberSuccess = (ServiceResult) => {
		setServiceResult([ServiceResult]);
	}

	const AdminUrbanizationApprovalByAllFiles = () => {
		var inputValue = {
			session: GetLocal('EmployeeSession')
		};
		FetchService("Employee/Urbanization/Request/AdminUrbanizationApprovalByAllFiles", inputValue, AdminUrbanizationApprovalByAllFilesSuccess, ServiceResultFail);
	}

	const AdminUrbanizationApprovalByAllFilesSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.FileListResult);
		if (ShowSuccess)
			toast.success('اطلاعات شما با موفقیت ذخیره گردید');
		ShowSuccess = null;
	}

	const ServiceResultFail = (ServiceResult) => {
		setServiceResult([]);
	}

	const ClearRefInput = () => {
		inpFilesRef.current.value = "";
	}

	const ShowFilesOperationAbstractListSuccess = (ServiceResult) => {
		setSelectData(ServiceResult.OperationInfo)
	}

	const ConfirmAction = (row) => {
		ResultRow = row;
		setResultRow(row)
		ShowModalConfirm();
	}

	const AdminUrbanizationApproval = (row) => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: getResultRow?.FileNumber,
			approvalType: getResultRow?.ApprovalType
		};
		

		EmployeeSessionCheckFetch("Employee/Urbanization/Request/AdminUrbanizationApproval", inputValue, AdminUrbanizationApprovalSuccess);
	}

	const AdminUrbanizationApprovalSuccess = () => {
		ShowSuccess = true;
		setShowModal(false);
		AdminUrbanizationApprovalByAllFiles();
	}

	const RejectAction = (row) => {
		ResultRow = row;
		setResultRow(row)
		ShowModalDescription();
	}

	let customRenderCell = {
		FilesReviewAction: (row) => (
			<ShowFilesReviewAbstractListAdmin RequestNumber={row.RequestNumber} FileNumber={row.FileNumber} />
		)
	};

	const ShowModalConfirm = () => {
		setShowModal('confirm');
		return (
			<Modal dialogClassName="modalConfirm" show={getShowModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					آیا از ادامه عملیات اطمینان دارید؟
				</Modal.Body>
				<Modal.Footer>
					<Button variant="success" onClick={() => AdminUrbanizationApproval()}>
						بله
					</Button>
					<Button variant="danger" onClick={() => setShowModal(false)}>
						خیر
					</Button>
				</Modal.Footer>
			</Modal>
		)
	}

	const ShowModalDescription = () => {
		setShowModal('description');
		return (
			<Modal dialogClassName="modalDescription" show={getShowModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<TextAreaControl
						inputRef={inpDescriptionRef}
						required={true}
						title='توضیحات:'
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="success" onClick={() => AdminUrbanizationDisapproval()}>
						ذخیره
					</Button>
					<Button variant="danger" onClick={() => setShowModal(false)}>
						بستن
					</Button>
				</Modal.Footer>
			</Modal>
		)
	}

	const AdminUrbanizationDisapproval = () => {
		if (IsEmptyInput(inpDescriptionRef))
			return false;

		var inputValue = {
			session: GetLocal('EmployeeSession'),
			fileNumber: getResultRow?.FileNumber,
			approvalType: getResultRow?.ApprovalType,
			description: inpDescriptionRef.current.value
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Request/AdminUrbanizationDisapproval", inputValue, AdminUrbanizationDisapprovalSuccess);
	}

	const AdminUrbanizationDisapprovalSuccess = () => {
		ShowSuccess = true;
		setShowModal(false);
		AdminUrbanizationApprovalByAllFiles();
	}

	const SetTypeLevel = (val) => {
		ServiceUrlCheckBox = val;
		ClearRefInput();
		setServiceResult([]);

		if (val == 'AdminUrbanizationApprovalByFileNumber')
			setFileNumberState(false);
		else
			setFileNumberState(true);
	}

	const BtnGetServiceResult = () => {
		if (ServiceUrlCheckBox == 'AdminUrbanizationApprovalByFileNumber')
			AdminUrbanizationApprovalByFileNumber();

		if (ServiceUrlCheckBox == 'AdminUrbanizationApprovalByAllFiles')
			AdminUrbanizationApprovalByAllFiles();
	}

	return (
		<div class="text-center my-4">
			<table dir="rtl" className="col col-sm-12 col-md-6">
				<tbody>
					<tr>
						<td style={{ "width": "10%" }}><input onClick={() => SetTypeLevel('AdminUrbanizationApprovalByFileNumber')} checked={getFileNumberState == 0} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "30%" }}>شماره پرونده</td>
						<td style={{ "width": "100%" }}>
							<TextBoxNumericControl
								required={true}
								maxlength={11}
								className="mt-3"
								inputRef={inpFilesRef}
								disabled={getFileNumberState}
								placeholder="شماره پرونده"
							/>
						</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('AdminUrbanizationApprovalByAllFiles')} checked={getFileNumberState == 1} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>کلیه پرونده ها</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td colspan="7" className="text-end">
							<ButtonControl
								variant="primary float-left w-25 mx-2"
								title="جستجو"
								onClick={BtnGetServiceResult}
								icon="fa fa-search"
							/>
						</td>
					</tr>
				</tbody>
			</table>

			<hr />

			<GridControl
				data={getServiceResult}
				customHeaders={{ "FileNumber": "شماره پرونده", "LastRequestDate": "تاریخ آخرین اقدام", "RegistrationPlaque": "پلاک ثبتی", "RenovationCode": "کد نوسازی", "FullName": "نام مالک", "ApprovalTitle": "نوع", "Address": "آدرس", "FilesReviewAction": "بازبینی پرونده", "RejectAction": "#", "ConfirmAction": "#" }}
				ConfirmAction={ConfirmAction}
				RejectAction={RejectAction}
				customRenderCell={customRenderCell}
			/>

			{getShowModal == 'confirm' && <ShowModalConfirm />}
			{getShowModal == 'description' && <ShowModalDescription />}
		</div>
	);
}
